"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var LANGUAGES_URI = 'blog-settings/v1/languages';
var DATETIME_FORMAT_OPTIONS = 'datetime-format-options';
var MONTH_FORMAT_OPTIONS = 'month-format-options';
var CUSTOM_DATETIME_FORMAT_OPTIONS = 'custom-datetime-format-option';
var SNAKE_CASING = 'snake';

var LanguagesAPI =
/*#__PURE__*/
function () {
  function LanguagesAPI() {
    (0, _classCallCheck2.default)(this, LanguagesAPI);
  }

  (0, _createClass2.default)(LanguagesAPI, null, [{
    key: "getDateTimeFormatOptions",
    value: function getDateTimeFormatOptions(language, selected) {
      return _apiClient.default.get(LANGUAGES_URI + "/" + DATETIME_FORMAT_OPTIONS, {
        query: {
          casing: SNAKE_CASING,
          language_str: language,
          selected_format: selected
        }
      });
    }
  }, {
    key: "getMonthFormatOptions",
    value: function getMonthFormatOptions(language, selected) {
      return _apiClient.default.get(LANGUAGES_URI + "/" + MONTH_FORMAT_OPTIONS, {
        query: {
          casing: SNAKE_CASING,
          language_str: language,
          selected_format: selected
        }
      });
    }
  }, {
    key: "createCustomDateTimeFormatOption",
    value: function createCustomDateTimeFormatOption(_ref) {
      var format_str = _ref.format_str,
          language_str = _ref.language_str;
      return _apiClient.default.post(LANGUAGES_URI + "/" + CUSTOM_DATETIME_FORMAT_OPTIONS, {
        query: {
          casing: SNAKE_CASING
        },
        data: {
          format_str: format_str,
          language_str: language_str
        }
      });
    }
  }]);
  return LanguagesAPI;
}();

exports.default = LanguagesAPI;
module.exports = exports.default;